export const FastEditstate = {
    data: null,
}